export default __webpack_public_path__ + "static/media/3_1.fb9f3a27.jpg";